"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemContainer = exports.System = void 0;
class System {
    constructor(scene, queries) {
        this.scene = scene;
        this.queries = queries;
    }
    initialize() { }
    destroy() { }
}
exports.System = System;
System.queries = {};
class SystemContainer {
    constructor(system, queries) {
        this.system = system;
        this.queries = queries;
    }
}
exports.SystemContainer = SystemContainer;
